import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import constants from './constants';
import noop from '../utils/noop';

const { ESCAPE_CODE } = constants;

function Overlay({ elementBounds, onOverLayClick = noop, borderRadius }) {
  const { left, top, width, height } = elementBounds;
  const { borderRadiusAxisX: rx, borderRadiusAxisY: ry } = borderRadius;
  const handleKeyPress = useCallback(
    (e) => {
      const { code } = e;
      if (code === ESCAPE_CODE) {
        onOverLayClick();
      }
    },
    [onOverLayClick]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <div className="ws-focal-point__overlay">
      <svg className="ws-focal-point__svg" onClick={onOverLayClick}>
        <defs>
          <mask id="substract">
            <rect width="100%" height="100%" fill="white" />
            <rect x={left} y={top} width={width} rx={rx} ry={ry} height={height} fill="black" />
          </mask>
        </defs>
        <rect
          className="ws-focal-point__mask"
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask="url(#substract)"
        />
      </svg>
    </div>
  );
}

Overlay.propTypes = {
  elementBounds: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    right: PropTypes.number.isRequired,
    bottom: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  borderRadius: PropTypes.shape({
    borderRadiusAxisX: PropTypes.string,
    borderRadiusAxisY: PropTypes.string,
  }).isRequired,
  onOverLayClick: PropTypes.func,
};

export default Overlay;
